<div class="navigation-trigger d-xl-none" [class.toggled]="sidebarVisible" (click)="toggleSidebarVisibility()">
    <div class="navigation-trigger__inner">
        <i class="navigation-trigger__line"></i>
        <i class="navigation-trigger__line"></i>
        <i class="navigation-trigger__line"></i>
    </div>
</div>

<!-- {{ isSidebarVisible }} -->